import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { toasts } from '@/utils/toasts';

export const restoreTaskType = ({ _id }: { _id: string }): Promise<void> => {
  return axios.post(`/task-types/${_id}/restore`);
};

type UseRestoreTaskTypeOptions = {
  config?: MutationConfig<typeof restoreTaskType>;
};

const TOAST_ID = 'restore-task-type';

export const useRestoreTaskType = ({ config = {} }: UseRestoreTaskTypeOptions = {}) => {
  return useMutation({
    ...config,
    onSuccess: (...args) => {
      queryClient.invalidateQueries(['task-types']);
      toasts.loadingToast.success(TOAST_ID, 'Task type restored');
      config.onSuccess?.(...args);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      toasts.loadingToast.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    onMutate: (...args) => {
      toasts.loadingToast.loading(TOAST_ID, 'Restoring...');
      config.onMutate?.(...args);
    },
    mutationFn: restoreTaskType,
  });
};
